import React, { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Ненавязчивый баннер под Navbar. Показывается ТОЛЬКО когда включён отпуск.
 * Dismissible на текущую сессию (sessionStorage), возвращается при перезагрузке.
 */
export default function VacationBanner() {
  const [data, setData] = useState(null);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem('svet_vacation_dismissed') === '1');

  useEffect(() => {
    let stopped = false;
    fetch(`${API}/api/schedule`)
      .then((r) => r.ok ? r.json() : Promise.reject(r.status))
      .then((d) => { if (!stopped) setData(d); })
      .catch(() => {/* nothing */});
    return () => { stopped = true; };
  }, []);

  // Синхронизируем сдвиг navbar через CSS-переменную --nav-offset
  useEffect(() => {
    const active = !!(data?.vacation?.enabled) && !hidden;
    document.documentElement.style.setProperty('--nav-offset', active ? '38px' : '0px');
    return () => document.documentElement.style.setProperty('--nav-offset', '0px');
  }, [data, hidden]);

  if (!data || !data.vacation?.enabled || hidden) return null;

  const { until, note } = data.vacation;

  const dismiss = () => {
    setHidden(true);
    try { sessionStorage.setItem('svet_vacation_dismissed', '1'); } catch {/* */}
  };

  return (
    <div
      className="w-full bg-wine/[0.08] border-b border-wine/25 text-ink text-[13.5px] fixed top-0 left-0 right-0 z-50"
      data-testid="vacation-banner"
      role="status"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-2.5 flex items-center gap-3">
        <span className="text-wine font-heading italic shrink-0">✧</span>
        <div className="flex-1 leading-snug">
          {until
            ? <>Светлана до <strong>{until}</strong> вне связи. {note}</>
            : <>{note || 'Светлана временно вне связи. Аня выслушает и запомнит.'}</>}
        </div>
        <button
          onClick={dismiss}
          className="text-ink/50 hover:text-ink text-[18px] leading-none px-1"
          aria-label="Скрыть уведомление"
          data-testid="vacation-dismiss"
        >
          ×
        </button>
      </div>
    </div>
  );
}
